var _require = require('./overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
var _require2 = require('../unlock_tx_edit'),
  escapeHtml = _require2.escapeHtml;
module.exports = {
  /**
   * Confirm-and-broadcast overlay. Fee amount is locked; funding is on unlock_transaction_final.
   */
  solutionOverlay: function solutionOverlay() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$feeDisplay = _ref.feeDisplay,
      feeDisplay = _ref$feeDisplay === void 0 ? '' : _ref$feeDisplay,
      _ref$outputSummary = _ref.outputSummary,
      outputSummary = _ref$outputSummary === void 0 ? '' : _ref$outputSummary;
    return buildRustscriptOverlay({
      className: 'rs-overlay-prompt rs-unlock-solution',
      title: 'Broadcast Unlock Transaction',
      titleClass: 'rs-spend-title',
      bodyHtml: "\n        <p class=\"rs-overlay-lead\">\n          Your unlock transaction is complete. Broadcast it to the Saito network.\n        </p>\n        <dl class=\"rs-unlock-confirm-meta\">\n          <div class=\"rs-unlock-confirm-row\">\n            <dt>Network fee</dt>\n            <dd>".concat(escapeHtml(feeDisplay || '—'), "</dd>\n          </div>\n          <div class=\"rs-unlock-confirm-row\">\n            <dt>Outputs</dt>\n            <dd>").concat(escapeHtml(outputSummary || 'Ready'), "</dd>\n          </div>\n        </dl>\n        <p class=\"rs-prompt-validation rs-unlock-error\" hidden role=\"alert\"></p>\n      "),
      actionsHtml: "<button type=\"button\" class=\"rs-btn rs-btn-primary\" data-action=\"unlock-broadcast\">Broadcast Unlock Transaction</button>",
      actionsClass: 'rs-overlay-actions-end'
    });
  }
};